module.exports = __webpack_public_path__ + "static/media/bp25.b741fd0f.jpg";